import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import get, { put } from "../../../../lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import CustomInput from "../../../../components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import { LoadingMgs } from "components/Common/toastify.jsx";
import { SuccessMessage } from "components/Common/toastify.jsx";
import { setCart } from "redux/ducks/cartSlice.js";
import { setDashboard } from "redux/ducks/CSPDashboardSlice.js";

const useStyles2 = makeStyles(headersStyle);

const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const ConfirmOrderCMP = () => {
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const [tenantDetails, setTenantDetails] = useState(null);
	const [percentage, setPercentage] = useState(0.0);
	const classes = useStyles();
	const customerDetails = useSelector((state) => state.customer);
	const dispatch = useDispatch();
	const cartDetails = useSelector((state) => state.cart);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		getCartsDetails();
		getTenantDetails();
		return function cleanup() {};
	}, []);

	const extractData = (cartItems) => {
		const productList = cartItems?.cartitems?.map((item) => {
			return [
				prepareTitle(item),
				inputQty(item),
				billingFrequency(item),
				"$" + item?.price,
				"$" + item?.total_price,
			];
		});
		return productList;
	};

	const extractDataDirectCustomer = (cartItems) => {
		const productList = cartItems?.cartitems?.map((item) => {
			return [
				prepareTitle(item),
				inputQty(item),
				billingFrequency(item),
				"$" + item?.reseller_price,
				inputPercentage(item),
				inputEndUserPriceEXGST(item),
				inputEndUserPriceInGST(item),
				"$" + item?.rrp,
				"$" + item?.commission,
				"$" + item?.total_price,
			];
		});
		console.log(productList, "productList");
		return productList;
	};

	const inputPercentage = (item) => {
		return (
			<CustomInput
				inputProps={{
					id: `percent_${item?.id}`,
					type: "number",
					placeholder: "Enter your percentage here",
					defaultValue: item?.percent,
					onKeyDown: (e) => keyDown(e),
					onChange: (e) => {
						if (e.key === "-" || e.key === "e" || e.target.value < 0) {
							e.target.value = 0;
							e.preventDefault();
							return;
						}
						updateProductToCartDirect(item, "percentage");
					},
				}}
				formControlProps={{
					fullWidth: false,
					className: classes2.formControl,
				}}
			/>
		);
	};

	const keyDown = (e) => {
		if (e.key === "-" || e.key === "e") {
			e.preventDefault();
		}
	};

	const inputEndUserPriceEXGST = (item) => {
		return (
			<CustomInput
				inputProps={{
					id: `price_${item?.id}`,
					type: "number",
					placeholder: "Enter your price here",
					defaultValue: item?.price,
					onKeyDown: (e) => keyDown(e),
					onChange: (e) => {
						if (e.key === "-" || e.key === "e" || e.target.value < 0) {
							e.target.value = 0;
							e.preventDefault();
							return;
						}
						updateProductToCartDirect(item, "price");
					},
				}}
				formControlProps={{
					fullWidth: false,
					className: classes2.formControl,
				}}
			/>
		);
	};

	const inputEndUserPriceInGST = (item) => {
		return (
			<CustomInput
				inputProps={{
					id: `price_inc_gst_${item?.id}`,
					type: "number",
					placeholder: "Enter your price inc gst here",
					defaultValue: item?.price_inc_gst,
					onKeyDown: (e) => keyDown(e),
					onChange: (e) => {
						if (e.key === "-" || e.key === "e" || e.target.value < 0) {
							e.target.value = 0;
							e.preventDefault();
							return;
						}
						updateProductToCartDirect(item, "price_inc_gst");
					},
				}}
				formControlProps={{
					fullWidth: false,
					className: classes2.formControl,
				}}
			/>
		);
	};

	const inputQty = (item) => {
		return (
			<CustomInput
				inputProps={{
					id: `qty_${item?.id}`,
					type: "number",
					placeholder: "Enter your quantity here",
					defaultValue: item?.quantity,
					onChange: (e) => {
						if (e.key === "-" || e.key === "e" || e.target.value <= 0) {
							e.target.value = 1;
							e.preventDefault();
							return;
						}
						updateProductToCart(item);
					},
				}}
				formControlProps={{
					fullWidth: false,
					className: classNames(classes2.formControl),
				}}
			/>
		);
	};

	const billingFrequency = (item) => {
		return (
			<select
				id={"billing_frequency_" + item?.id}
				onChange={() => {
					updateProductToCart(item);
				}}>
				<option value="Monthly">Monthly</option>
				<option value="Annual">Annual</option>
			</select>
		);
	};

	const prepareTitle = (product) => {
		return (
			<>
				<div className={classesCSStyles?.labelAc}>
					<h4>{product.Description}</h4>
				</div>
				<div>
					STOCK CODE: <span>{product.Stockcode}</span>
				</div>
			</>
		);
	};

	const getCartsDetails = async () => {
		setLoading(true);
		try {
			await get(`/api/cart/list/${customerDetails?.tenantId}`, true)
				.then((res) => {
					const response = res.data.records;
					if (res.data.success) {
						dispatch(setCart(response));
						const cartItems = response.cartitems;
						cartItems.map((item) => {
							const itemId = item?.id;
							const qty = document.getElementById(`qty_${itemId}`);
							qty.value = item?.quantity;

							const billingFrequency = document.getElementById(
								`billing_frequency_${item?.id}`
							);
							billingFrequency.value = item?.billing_frequency;

							if (response.directcustomer) {
								const itemPrice = item?.price;
								const price = document.getElementById(`price_${itemId}`);
								price.value = itemPrice;

								const itemPriceInc = item?.price_inc_gst;
								const price_inc_gst = document.getElementById(
									`price_inc_gst_${itemId}`
								);
								price_inc_gst.value = itemPriceInc;

								const itemPercent = item?.percent;
								const percentage = document.getElementById(`percent_${itemId}`);
								percentage.value = itemPercent;
							}
						});
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Products", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					console.log(error, "error");
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const moveToCompleteOrder = () => {
		dispatch(
			setDashboard({
				OrderSummary: true,
				ConfirmOrder: false,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: null,
			})
		);
	};

	const cancelOrder = () => {
		dispatch(
			setDashboard({
				OrderSummary: false,
				ConfirmOrder: false,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: true,
				AddCustomerSubscription: false,
				selectedDialogData: null,
			})
		);
	};

	async function updateProductToCart(item) {
		const qty = document.getElementById(`qty_${item?.id}`)?.value;
		const billingFrequency = document.getElementById(
			`billing_frequency_${item?.id}`
		)?.value;

		if (!qty) {
			ErrorMessage("Update to Cart", "Please enter quantity");
			return;
		}

		if (!billingFrequency) {
			ErrorMessage("Update to Cart", "Please select billing frequency");
			return;
		}

		setLoading(true);
		LoadingMgs("Update to Cart", "processing...");

		const formField = {
			cart_item_id: item?.id,
			quantity: qty,
			csp_order_id: cartDetails?.csp_order_id,
			billing_frequency: billingFrequency,
		};

		try {
			await put(`/api/cart/update/${customerDetails?.tenantId}`, formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Update to Cart", res.data.message);
						dispatch(setCart(res.data.records));
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;

						getCartsDetails();
					} else {
						ErrorMessage("Update to Cart", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Update to Cart", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Update to Cart", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	async function updateProductToCartDirect(item, title) {
		const qty = document.getElementById(`qty_${item?.id}`)?.value;
		const billingFrequency = document.getElementById(
			`billing_frequency_${item?.id}`
		)?.value;

		if (!qty) {
			ErrorMessage("Update to Cart", "Please enter quantity");
			return;
		}

		if (!billingFrequency) {
			ErrorMessage("Update to Cart", "Please select billing frequency");
			return;
		}

		setLoading(true);
		LoadingMgs("Update to Cart", "processing...");

		const formField = {
			cart_item_id: item?.id,
			quantity: qty,
			csp_order_id: cartDetails?.csp_order_id,
			billing_frequency: billingFrequency,
		};

		if (cartDetails?.directcustomer) {
			if (title === "price") {
				const price = document.getElementById(`price_${item?.id}`)?.value;
				if (!price) {
					ErrorMessage("Update to Cart", "Please enter price");
					return;
				}
				formField.field_name = "price_ex";
				formField.field_value = price;
			} else if (title === "price_inc_gst") {
				const price_inc_gst = document.getElementById(`price_inc_gst_${item?.id}`)
					?.value;
				if (!price_inc_gst) {
					ErrorMessage("Update to Cart", "Please enter price inc gst");
					return;
				}
				formField.field_name = "price_inc";
				formField.field_value = price_inc_gst;
			} else if (title === "percentage") {
				const percentage = document.getElementById(`percent_${item?.id}`)?.value;
				if (!percentage) {
					ErrorMessage("Update to Cart", "Please enter percentage");
					return;
				}

				formField.field_name = "percentage";
				formField.field_value = percentage;
			}
		}

		try {
			await put(`/api/cart/update/${customerDetails?.tenantId}`, formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Update to Cart", res.data.message);
						dispatch(setCart(res.data.records));
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;
						getCartsDetails();
					} else {
						ErrorMessage("Update to Cart", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Update to Cart", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Update to Cart", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	const getTenantDetails = async () => {
		setLoading(true);
		try {
			await get(`/api/tenant/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						setTenantDetails(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;

						console.log(errorMsg, "errorMsg");
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Carts details", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Carts details", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	return (
		<div className={classesCSStyles.mx5}>
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader color="info" className="">
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>
								CONFIRM ORDER- PRO RATA PAYMENT CALCULATION
							</h4>
						</GridItem>
					</GridContainer>
				</CardHeader>
				<CardBody
					className={classNames(
						classesCSStyles.accountSection,
						classesCSStyles.my10
					)}>
					<GridContainer className={classNames(classesCSStyles.marginAuto)}>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(loading ? classesCSStyles.loading : "")}>
							<div
								className={classNames(
									classesCSStyles.searchWrapper,
									classes2.mlAuto,
									classesCSStyles?.confirmOrderBox,
									classesCSStyles?.my10
								)}>
								<div>
									<div className={classesCSStyles?.labelAc}>Customer</div>{" "}
									{tenantDetails &&
										`${tenantDetails?.tenant?.FirstName}  ${tenantDetails?.tenant?.LastName} `}
								</div>{" "}
								<div>
									<div className={classesCSStyles?.labelAc}>Address </div>
									{tenantDetails &&
										`${tenantDetails?.tenant?.Address01},  ${tenantDetails?.tenant?.Address02}, ${tenantDetails?.tenant?.Address03}, ${tenantDetails?.tenant?.Country}, ${tenantDetails?.tenant?.State}, ${tenantDetails?.tenant?.Suburb}, ${tenantDetails?.tenant?.Postcode}`}{" "}
								</div>
								<div>
									<div className={classesCSStyles?.labelAc}>Telephone </div>{" "}
									{tenantDetails && `${tenantDetails?.tenant?.Phone}   `}{" "}
								</div>
								<div>
									<div className={classesCSStyles?.labelAc}>Email </div>{" "}
									{tenantDetails && `${tenantDetails?.tenant?.Email}  `}
								</div>
							</div>
							{!cartDetails?.directcustomer ? (
								<>
									{cartDetails?.cartitems?.length > 0 ? (
										<Table
											striped
											tableHead={[
												"ITEMS",
												"QTY",
												"BILLING FREQUENCY",
												"PRICE S (EX GST)",
												"TOTAL $ (EX GST)",
											]}
											tableData={extractData(cartDetails)}
											customCellClasses={[
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
											]}
											customClassesForCells={[0, 1, 2, 3, 4, 5]}
											customHeadCellClasses={[
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
											]}
											customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
										/>
									) : (
										<div className={classNames(classesCSStyles?.my10)}>
											No items in cart!
										</div>
									)}
								</>
							) : (
								<>
									{cartDetails?.cartitems?.length > 0 ? (
										<Table
											striped
											tableHead={[
												"ITEMS",
												"QTY",
												"BILLING FREQUENCY",
												"RESELLER PRICE (EX GST)($)",
												"PERCENTAGE (%)",
												"END USER PRICE (EX GST)($)",
												"END USER PRICE (INC.GST)($)",
												"MICROSOFT RRP (INC.GST)($)",
												"COMMISSION PRICE (EX GST)($)",
												"TOTAL $ (EX GST)",
											]}
											tableData={extractDataDirectCustomer(cartDetails)}
											customCellClasses={[
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
												classes.textLeft,
											]}
											customClassesForCells={[0, 1, 2, 3, 4, 5]}
											customHeadCellClasses={[
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
												classNames(
													classes.textLeft,
													classesCSStyles?.labelAc,
													classesCSStyles?.tableHeaderCell
												),
											]}
											customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
										/>
									) : (
										<div className={classNames(classesCSStyles?.my10)}>
											No items in cart!
										</div>
									)}
								</>
							)}
							{loading && (
								<Loading
									width={30}
									height={30}
									className={classesCSStyles.absoluteLoading}
								/>
							)}
							{!loading && cartDetails?.length === 0 && (
								<div className={classNames(classesCSStyles?.my10)}>
									No items in cart!
								</div>
							)}
						</GridItem>
						<GridItem xs={12} sm={12} md={12}>
							<hr />
							<div className={classesCSStyles?.my10}>
								* A transaction charge will apply per debit transaction at time of
								billing A surcharge will apply to all orders paid by credit card
							</div>
						</GridItem>
						<GridItem xs={12} sm={12} md={12} lg={12}>
							<label>
								<h4 className={classesCSStyles?.labelAc}>Special Instruction</h4>
							</label>
							<CustomInput
								inputProps={{
									placeholder: "Enter Special Instruction",
									value: cartDetails?.special_instruction,
									onChange: (e) => {
										dispatch(
											setCart({
												...cartDetails,
												special_instruction: e.target.value,
											})
										);
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
						</GridItem>
						<GridItem
							xs={12}
							sm={12}
							md={6}
							lg={6}
							className={classNames(classesCSStyles?.my10)}></GridItem>
						<GridItem
							xs={12}
							sm={12}
							md={6}
							lg={6}
							className={classNames(classesCSStyles?.my10)}>
							<Card
								className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
								<CardHeader color="info" className="">
									<GridContainer>
										<GridItem xs={12} sm={6} md={6}>
											<h4 className={classesCSStyles?.cartLabel}>Provision Now</h4>
										</GridItem>
									</GridContainer>
								</CardHeader>
								<CardBody
									className={classNames(
										classesCSStyles.accountSection,
										classesCSStyles.my10
									)}>
									As a premium cloud reseller you can create subscriptions based on your
									credit limit. You wil be charged according to your payment method set
									up with us.
									<div
										className={classNames(
											classesCSStyles?.my10,
											classesCSStyles?.moveRight
										)}>
										<button
											className={classNames(classesCSStyles?.buttonPrimary)}
											onClick={() => moveToCompleteOrder()}>
											Create License
										</button>
										{/* <Button
											color="info"
											size="sm"
											onClick={() => moveToCompleteOrder()}></Button> */}
										&nbsp;
										<Button color="danger" size="sm" onClick={() => cancelOrder()}>
											CANCEL
										</Button>
									</div>
								</CardBody>
							</Card>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
		</div>
	);
};

export default ConfirmOrderCMP;
